import { useCallback, useMemo } from "react";
import { useAtom } from "jotai";
import jsonViewerAtom from "@/atom/jsonViewer";
import { useModal } from ".";


export const GLOBAL_JSON_VIEWER_ID = "global-json-viewer-id";

export const useJSONViewer = () => {
    const modal = useModal();
    const [viewerState, setViewerState] = useAtom(jsonViewerAtom);

    const data = useMemo(() => viewerState.data, [viewerState]);
    const title = useMemo(() => viewerState.title, [viewerState]);

    const open = useCallback((title: string, data: object) => {
        modal.open(GLOBAL_JSON_VIEWER_ID);
        setViewerState({
            title: title,
            data: data
        });
    }, [modal, setViewerState]);

    const close = useCallback(() => {
        modal.close(GLOBAL_JSON_VIEWER_ID);
    }, [modal]);

    return useMemo(() => {
        return {
            open,
            close,
            title,
            data
        };
    }, [open, close, title, data]);
};
